// extracted by mini-css-extract-plugin
export default {"deleteButton":"styles_deleteButton__5J7Ks"};